import { useMemo } from 'react'

import type { EclipseContacts } from '@/config/eclipse'

import { useNow } from './useNow'

export type EclipsePhase = 'before' | 'partial' | 'totality' | 'after'

/** Which stage of the eclipse the clock is in right now. */
export function useEclipsePhase(contacts: EclipseContacts): EclipsePhase {
  const now = useNow(1000)

  return useMemo(() => {
    const at = (iso: string) => new Date(iso).getTime()

    if (now < at(contacts.partialBegin)) return 'before'
    if (now < at(contacts.totalityBegin)) return 'partial'
    if (now < at(contacts.totalityEnd)) return 'totality'
    if (now < at(contacts.partialEnd)) return 'partial'
    return 'after'
  }, [now, contacts])
}
